module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan3-3-c8cfcf5756585d26b9a408074e1a8189.webp";